import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const UPDATE_APP_INFO = 'UPDATE_APP_INFO';
const UPDATE_ORIGIN_KEY = 'UPDATE_ORIGIN_KEY';
const UPDATE_CURRENT_PHOTO = 'UPDATE_CURRENT_PHOTO';
const UPDATE_SIZE_LIST = 'UPDATE_SIZE_LIST';
const UPDATE_CHOOSE_SIZE_INFO = 'UPDATE_CHOOSE_SIZE_INFO';
const UPDATE_CLOTHES_ID = 'UPDATE_CLOTHES_ID';
const UPDATE_FAIR_LEVEL = 'UPDATE_FAIR_LEVEL';
const UPDATE_BG_SELECTED = 'UPDATE_BG_SELECTED';


export default new Vuex.Store({

  state: {
    appInfo: JSON.parse(sessionStorage.getItem(`appInfo`))||{}, // app总信息
    originKey:sessionStorage.getItem('originKey')?sessionStorage.getItem('originKey'):null,
    currentPhoto:JSON.parse(sessionStorage.getItem(`currentPhoto`))||[], // 当前制作的照片url
    sizeList:[],
    sizeInfo:JSON.parse(sessionStorage.getItem(`sizeInfo`))||{}, // 已选的规格参数
    bgNameSelected:sessionStorage.getItem('bgNameSelected')||'',//背景色名称,
    clothesId:sessionStorage.getItem('clothesId'),//换装参数,
    fairLevel:sessionStorage.getItem(`fairLevel`)!=='undefined'?JSON.parse(sessionStorage.getItem(`fairLevel`)):{}
  },

  getters: {
    getAppInfo: state => state.appInfo,
    getOriginKey: state => state.originKey,
    getCurrentPhoto: state => state.currentPhoto,
    getSizeList: state => state.sizeList,
    getSizeInfo: state => state.sizeInfo,
    getClothesId: state => state.clothesId,
    getFairLevel: state => state.fairLevel,
  },

  mutations: {
    [UPDATE_APP_INFO](state, data) {
      sessionStorage.setItem(`appInfo`, JSON.stringify(data))
      state.appInfo = data
    },
    [UPDATE_ORIGIN_KEY](state, data) {
      sessionStorage.setItem(`originKey`, data)
      state.originKey = data
    },
    [UPDATE_CURRENT_PHOTO](state, data) {
      sessionStorage.setItem(`currentPhoto`, JSON.stringify(data))
      state.currentPhoto = data
    },
    [UPDATE_SIZE_LIST](state, data) {
      state.sizeList = data
    },
    [UPDATE_CHOOSE_SIZE_INFO](state, data) {
      sessionStorage.setItem(`sizeInfo`, JSON.stringify(data))
      state.sizeInfo = data
    },
    [UPDATE_BG_SELECTED](state, data) {
      sessionStorage.setItem(`bgNameSelected`, data)
      state.bgNameSelected = data
    },
    [UPDATE_CLOTHES_ID](state, data) {
      sessionStorage.setItem(`clothesId`, data)
      state.clothesId = data
    },
    [UPDATE_FAIR_LEVEL](state, data) {
      sessionStorage.setItem(`fairLevel`, JSON.stringify(data))
      state.fairLevel = data
    },

  },
  actions: {
    updateAppInfo(context, data) {
      context.commit(UPDATE_APP_INFO, data)
    },

    updateOriginKey(context, data) {
      context.commit(UPDATE_ORIGIN_KEY, data)
    },

    updateCurrentPhoto(context, data) {
      context.commit(UPDATE_CURRENT_PHOTO, data)
    },

    updateSizeList(context, data) {
      context.commit(UPDATE_SIZE_LIST, data)
    },

    updateSizeInfo(context, data) {
      context.commit(UPDATE_CHOOSE_SIZE_INFO, data)
    },
    updateClothesId(context, data){
      context.commit(UPDATE_CLOTHES_ID, data)
    },
    updateFairLevel(context, data){
      context.commit(UPDATE_FAIR_LEVEL, data)
    },
    updateBgSelected(context, data){
      context.commit(UPDATE_BG_SELECTED, data)
    },
  },
});
